export const touchUserContextData = (context) => {
  context.setUser({
    ...context.user,
    touchedAt: Date.now()
  })
}
